/* eslint-disable camelcase */
import { Car, CarImage, CarMileageEntry } from '../../models';
import { GET_CARS } from '../constants/scannedCars';

// eslint-disable-next-line import/prefer-default-export
export const getScannedCars = (ownerId, data) => {
  const { is_workshop_ownership: isWorkshopOwnership, workshop_scan_qr_codes: scanQRCodes } = data;
  const convertedCars = scanQRCodes.map((item) => {
    const { id, ownership, workshop_ownership, visit, created_at } = item;
    const { car, images, mileage_entries } = ownership;
    const image = images?.length > 0 ? new CarImage(images[0].id, images[0].image) : null;
    const mileageEntry =
      mileage_entries?.length > 0
        ? new CarMileageEntry(mileage_entries[0].id, mileage_entries[0].mileage_in_kilometers)
        : null;

    const convertedCar = new Car(
      car.id,
      car.make_name,
      car.model_name,
      car.variant,
      car.version,
      car.vin,
      car.production_year,
      car.fuel,
      car.engine_capacity,
      car.engine_power_kw,
      car.curb_weight,
      car.first_registration_date,
      ownership.car_nickname,
      ownership.color,
      ownership.owner_id,
      ownership.registration_number,
      ownership.id,
      ownership.finished_at === null,
      image,
      mileageEntry,
    );
    return {
      id,
      car: convertedCar,
      workshopOwnershipId: workshop_ownership,
      visitId: visit,
      createdAt: created_at,
    };
  });

  return (dispatch) => {
    dispatch({
      type: GET_CARS,
      ownerId,
      isWorkshopOwnership,
      cars: convertedCars,
    });
  };
};
